import React, { useState, useEffect, useCallback } from "react";
import { getSuperUserInfo, getAccountInfo } from "../../services/backendApi";
import Button from "@material-ui/core/Button";
import api from "../../services/api";
import Spinner from "../presentation/spinner";
import * as styled from "./styled";
import {Modal} from "react-bootstrap";

const SuperUserList = () => {
  const [accountInfo, setAccountInfo] = useState();
  const [userInfo, setUserInfo] = useState();
  const [tableData, setTableData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshUsers, setRefreshUsers] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState()

  useEffect(() => {
    const requestUserInfo = async () => {
      const userData = await getSuperUserInfo();
      setUserInfo(userData);
    };
    const requestAccountInfo = async () => {
      const accountData = await getAccountInfo();
      setAccountInfo(accountData);
    };
    if (refreshUsers) {
      setRefreshUsers(false);
      setTableData();
      setUserInfo();
      setAccountInfo();
      requestUserInfo();
      requestAccountInfo();
    }
  }, [refreshUsers]);

  // This useEffect extracts the table data from the two sources of accountInfo and userInfo
  useEffect(() => {
    if (userInfo && accountInfo) {
      const tableInfo = userInfo.validSuperUsers.map(user => {
        const targetAccount = accountInfo.find(
          account => account._id === user.mongoData?.accountId
        );
        const superAdminAttribute = Boolean(user.customClaims["custom:superAdmin"])
        const mfaRequiredAttribute = Boolean(user.customClaims["custom:mfaRequired"])
        const mfaLinkedAttribute = Boolean(user.customClaims["custom:mfaLinked"]);
        return {
          email: user.Username,
          account: targetAccount ? targetAccount.name : "Not Found",
          superAdminFlag: superAdminAttribute,
          mfaRequiredCognito: mfaRequiredAttribute
            ? mfaRequiredAttribute
            : "Not Found",
          mfaLinked: mfaLinkedAttribute
            ? mfaLinkedAttribute
            : "Not Found",
          presentInMongo: Boolean(user.mongoData).toString(),
          mfaRequiredMongo:
            user.mongoData?.mfaRequired !== undefined
              ? user.mongoData?.mfaRequired.toString()
              : "Not Found",
          id: user.mongoData?._id,
          userBody: user.mongoData
        };
      });
      setTableData(tableInfo);
    }
  }, [userInfo, accountInfo]);

  const onCloseModal = () => {
    setUserToDelete(undefined)
    setShowModal(false)
  }

  const onDeleteUser = useCallback(
    async userId => {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      try {
        await api.deleteUser(userId)
        setRefreshUsers(true);
        onCloseModal()
      } catch (err) {
        console.log(err);
        alert("An error occurred deleting the user");
      }
      setIsLoading(false);
    },
    [isLoading]
  );

  const onEnableMfa = useCallback(
    async userBody => {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      try {
        const updatedUser = {
          ...userBody,
          mfaRequired: true
        };
        await api.updateUser(userBody._id, updatedUser);
        setRefreshUsers(true);
      } catch (err) {
        console.log(err);
        alert("An error occurred updating the user");
      }
      setIsLoading(false);
    },
    [isLoading]
  );

  if (!tableData) {
    return (
      <styled.SuperUserListWrapper>
        <Spinner size={200} />
      </styled.SuperUserListWrapper>
    );
  }

  return (
    <styled.SuperUserListWrapper>
      <styled.UserTable>
        <styled.TableHeader>
          <styled.TableRow>
            <styled.HeaderCell>Email</styled.HeaderCell>
            <styled.HeaderCell>Account</styled.HeaderCell>
            <styled.HeaderCell>Super Admin Flag</styled.HeaderCell>
            <styled.HeaderCell>MFA Required (Cognito)</styled.HeaderCell>
            <styled.HeaderCell>MFA Linked (Cognito)</styled.HeaderCell>
            <styled.HeaderCell>Present In DB</styled.HeaderCell>
            <styled.HeaderCell>MFA Required (DB)</styled.HeaderCell>
            <styled.HeaderCell>Enable MFA</styled.HeaderCell>
            <styled.HeaderCell>Delete User</styled.HeaderCell>
          </styled.TableRow>
        </styled.TableHeader>
        <styled.TableBody>
          {tableData.map(rowData => (
            <styled.TableRow key={rowData.email}>
              <styled.TableCell>{rowData.email}</styled.TableCell>
              <styled.TableCell>{rowData.account}</styled.TableCell>
              <styled.TableCell>
                <styled.StatusIndicator
                  valid={rowData.superAdminFlag === true}
                />
              </styled.TableCell>
              <styled.TableCell>
                <styled.StatusIndicator
                  valid={rowData.mfaRequiredCognito === true}
                />
              </styled.TableCell>
              <styled.TableCell>
                <styled.StatusIndicator valid={rowData.mfaLinked === true} />
              </styled.TableCell>
              <styled.TableCell>
                <styled.StatusIndicator
                  valid={rowData.presentInMongo === "true"}
                />
              </styled.TableCell>
              <styled.TableCell>
                <styled.StatusIndicator
                  valid={rowData.mfaRequiredMongo === "true"}
                />
              </styled.TableCell>
              <styled.TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isLoading || !rowData.id || (rowData.mfaRequiredCognito === true && rowData.mfaRequiredMongo === "true")}
                  onClick={() => onEnableMfa(rowData.userBody)}
                >
                  Enable MFA
                </Button>
              </styled.TableCell>
              <styled.TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isLoading || !rowData.id}
                  onClick={() => {
                    setShowModal(true)
                    setUserToDelete(rowData.userBody)
                  }}
                >
                  Delete User
                </Button>
              </styled.TableCell>
            </styled.TableRow>
          ))}
        </styled.TableBody>
      </styled.UserTable>
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            Are you sure you want to delete this user?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="edit-project-confirmation-modal">
            <div className="flex">
              <p>
                {isLoading ? 'Delete in progress ...' : `THIS WILL PERMANENTLY DELETE THE USER: ${userToDelete?.username}`}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize="large" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button
              bsStyle="success"
              bsSize="large"
              onClick={() => onDeleteUser(userToDelete?._id)}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </styled.SuperUserListWrapper>
  );
};

export default SuperUserList;
